import * as React from 'react'
import {useSafeCallbackExtraDeps, unCallbackFn} from '@freckle/react-hooks'

import DistrictSearchButton from '@frontrow/console/src/components/common/district-search-button/district-search-button'
import {type DistrictT} from '@frontrow/console/src/models/district'
import {fromOpenApiDistricts} from '@frontrow/console/src/models/district'
import {fetchDistricts} from '@frontrow/console/src/helpers/api-districts'

type Props = {
  districtId?: number
  onPostFetch: (districts: Array<DistrictT>) => void
}

export default function DistrictSearchButtonContainer(props: Props): React.ReactElement {
  const {districtId} = props

  const initialDistrictId =
    districtId !== null && districtId !== undefined ? districtId.toString() : ''

  const [districtIdValue, setDistrictIdValue] = React.useState<string>(initialDistrictId)
  const [isFetching, setIsFetching] = React.useState<boolean>(false)

  const onInputChange = (e: React.ChangeEvent): void => {
    const districtIdValue = (e.target as HTMLInputElement).value
    setDistrictIdValue(districtIdValue)
  }

  const fetchDistrict = useSafeCallbackExtraDeps<
    (e: React.FormEvent<HTMLFormElement>) => void,
    {
      onPostFetch: (districts: Array<DistrictT>) => void
    }
  >(
    ({onPostFetch}) =>
      (e: React.FormEvent<HTMLFormElement>): void => {
        e.preventDefault()

        setIsFetching(true)
        fetchDistricts({
          filters: [{id: 'district.id', value: districtIdValue}]
        })
          .then(response => {
            return fromOpenApiDistricts(response)
          })
          .then(result => {
            setIsFetching(false)
            onPostFetch(result)
          })
      },
    [districtIdValue], // primitive dependencies
    {
      onPostFetch: {value: props.onPostFetch, comparator: () => true}
    }
  )

  return (
    <DistrictSearchButton
      districtIdInputValue={districtIdValue}
      onInputChange={onInputChange}
      onSubmit={unCallbackFn(fetchDistrict)}
      isFetching={isFetching}
    />
  )
}
